<template>
  <div class="HeaderForm">
    <el-row type="flex" justify="space-between">
      <el-col :span="leftSpan">
        <slot name="prepend"></slot>
      </el-col>
      <el-col :span="24-leftSpan" class="flexEnd">
        <slot name="append"></slot>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'HeaderForm',
  props: {
    leftSpan: {
      type: Number,
      default: 16
    }
  }
}
</script>

<style scoped>
.HeaderForm {
  background: #fff;
  padding-top: 10px;
}
.flexEnd {
  display: flex;
  justify-content: flex-end;
}
</style>
